import './CSS/style.css';
import * as XLSX from 'xlsx';
import { message } from 'antd';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { DownloadOutlined } from '@ant-design/icons';

import localStorage from '../../../../../utils/localStorage';
import { IPAddress, SAMPLE } from '../../../../../commons/api';
import StyledTable from '../../../../../commons/styles/table';
import { getTableListFromAPI, uploadJsonData } from './Utils/apicalls';
import { StyledHomepage } from '../../../../../commons/styles/layout';

const InHouseRegistration = (props) => {
  const [dataSource, setDataSource] = useState([]);
  // const translationList = {
  //   'Hole Number': '穴番号',
  //   'Gun Powder Quantity': '薬量',
  //   Design: '設計',
  //   Actual: '実績',
  //   'No Of Explosives with Detonators': '親ダイ',
  //   'No Of Explosives without Detonators': '増ダイ'
  // };

  useEffect(() => {
    getTableList();
  }, []);

  const getTableList = async () => {
    const dataSource = await getTableListFromAPI();
    setDataSource(dataSource);
  };

  const onFileUpload = (e) => {
    e.preventDefault();
    const files = e.target.files;
    const f = files[0];
    const reader = new FileReader();

    reader.onload = async (e) => {
      const dataa = e.target.result;
      const readedData = XLSX.read(dataa, { type: 'binary' });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const data =
        dataParse &&
        Array.isArray(dataParse) &&
        dataParse
          .filter((_, i) => i > 2)
          .map((data) => ({
            HoleNumber: data[0],
            NoOfExplosivesWithDetonators_Design: data[1],
            NoOfExplosivesWithOutDetonators_Design: data[2],
            NoOfExplosivesWithDetonators_Actual: data[3],
            NoOfExplosivesWithOutDetonators_Actual: data[4]
          }));

      const saveExcel = await uploadJsonData(data);
      if (saveExcel && saveExcel.message) {
        message.success(saveExcel.message);
        getTableList();
      }
    };
    reader.readAsBinaryString(f);
  };

  const translation = (keyword) => {
    const { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const columns = [
    {
      title: translation('Hole Number'),
      dataIndex: 'HoleNumber',
      key: 'HoleNumber'
    },
    {
      title: translation('Gun Powder Quantity'),
      dataIndex: 'GunPowderQuantity',
      key: 'GunPowderQuantity',
      children: [
        {
          title: translation('Design'),
          dataIndex: 'Design',
          key: 'Design',
          children: [
            {
              title: translation('No Of Explosives with Detonators'),
              dataIndex: 'NoOfExplosivesWithDetonators_Design',
              key: 'NoOfExplosivesWithDetonators_Design'
            },
            {
              title: translation('No Of Explosives without Detonators'),
              dataIndex: 'NoOfExplosivesWithOutDetonators_Design',
              key: 'NoOfExplosivesWithOutDetonators_Design'
            }
          ]
        },
        {
          title: translation('Actual'),
          dataIndex: 'Actual',
          key: 'Actual',
          children: [
            {
              title: translation('No Of Explosives with Detonators'),
              dataIndex: 'NoOfExplosivesWithDetonators_Actual',
              key: 'NoOfExplosivesWithDetonators_Actual'
            },
            {
              title: translation('No Of Explosives without Detonators'),
              dataIndex: 'NoOfExplosivesWithOutDetonators_Actual',
              key: 'NoOfExplosivesWithOutDetonators_Actual'
            }
          ]
        }
      ]
    }
  ];

  const siteId = localStorage.get('currentSite');

  return (
    <StyledHomepage>
      <div className="headerCSS">{translation('In-House Standard Registration')}</div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <input type="file" style={{ margin: '5px 0px' }} onChange={onFileUpload} />
        <div style={{ margin: '5px 0px', fontWeight: '18px' }}>
          <DownloadOutlined style={{ marginRight: '2px' }} />
          <a
            target={'_blank'}
            style={{ color: '#262222' }}
            href={`${IPAddress.LOCAL}${SAMPLE.Okumura}?SiteId=${siteId}`}
            rel="noopener noreferrer"
          >
            {translation('Download Default Template')}
          </a>
        </div>
      </div>
      <div>
        <StyledTable size="small"
          columns={columns}
          bordered={true}
          dataSource={dataSource}
        />
      </div>
    </StyledHomepage>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(InHouseRegistration);
